import classNames from 'classnames/bind';
import styles from './Slider.module.css';

import { Swiper, SwiperSlide, SwiperProps } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

import { useSwiperRef } from '../../hooks/useSwiper';

import { LibraryList, ResourceList, SharedLibraryList } from '../../types/main';

import Book from '../Book';
import {
  NEXT,
  PREV,
  SLIDER_SPACE_BETWEEN,
  SLIDER_SPACE_BETWEEN_ACTIVITY,
} from '../../constants';
import { isMobile } from '../../utils/util';
import ActivityBook from '../../pages/Classroom/Book';
import { ActivityProject, ActivityProjectList } from '../../types/analysis';
import { useAppSelector } from '../../hooks/useRedux';
import {
  selectGroupProjectId,
  selectMyProjectId,
  selectStudentProjectId,
  selectStudentUserId,
} from '../../features/analysisSlice';
import { useLocation } from 'react-router-dom';
import { RefObject } from 'react';

interface Slider {
  name?: string;
  list: LibraryList | SharedLibraryList | ResourceList | ActivityProjectList;
  dashSectionRef?: RefObject<HTMLDivElement>;
}

export default function Slider({ name, list, dashSectionRef }: Slider) {
  const cx = classNames.bind(styles);
  const { pathname } = useLocation();

  const [nextEl, nextElRef] = useSwiperRef<HTMLButtonElement>();
  const [prevEl, prevElRef] = useSwiperRef<HTMLButtonElement>();

  const isActivityInfo = name?.includes('activity');
  const isEbookActivity = pathname.includes('ebook-activity');

  const options: SwiperProps = {
    wrapperTag: 'ul',
    modules: [Navigation],
    navigation: {
      prevEl,
      nextEl,
    },
    spaceBetween: isActivityInfo
      ? SLIDER_SPACE_BETWEEN_ACTIVITY
      : SLIDER_SPACE_BETWEEN,
    slidesPerView: 'auto',
  };

  const userId = useAppSelector(selectStudentUserId);
  const selectedProjectId = useAppSelector(
    userId
      ? selectStudentProjectId
      : isEbookActivity
      ? selectGroupProjectId
      : selectMyProjectId
  );

  return (
    <div className={cx('slide_area', name)}>
      <div className={cx('slide_content')}>
        <Swiper className={cx('book_list')} {...options}>
          {list.map((item, index) => (
            <SwiperSlide
              key={
                'projectId' in item
                  ? item.projectId
                  : 'resourceId' in item
                  ? item.resourceId
                  : index
              }
              className={cx('slide-list', {
                active:
                  'projectId' in item && item.projectId === selectedProjectId,
              })}
              tag="li"
            >
              {isActivityInfo ? (
                <ActivityBook
                  type="list"
                  item={item as ActivityProject}
                  itemIndex={index}
                  dashSectionRef={dashSectionRef}
                />
              ) : (
                <Book name={name} item={item}></Book>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {isMobile || (
        <div className={cx('slide_nav')}>
          <button ref={prevElRef} className={cx('slide_prev')}>
            <span className={cx('blind')}>{PREV}</span>
          </button>
          <button ref={nextElRef} className={cx('slide_next')}>
            <span className={cx('blind')}>{NEXT}</span>
          </button>
        </div>
      )}
    </div>
  );
}
